// Pure step-transition logic for a running guide, kept free of React/DOM so it can be unit-tested.

/** The next step index, or "done" when advancing past the last step (the tour should stop). */
export function nextStep(current: number, total: number): number | "done" {
  return current >= total - 1 ? "done" : current + 1;
}

/** The previous step index, clamped at the first step. */
export function prevStep(current: number): number {
  return current <= 0 ? 0 : current - 1;
}

/** Whether the given index is the last step of a guide with `total` steps. */
export function isLastStep(current: number, total: number): boolean {
  return current >= total - 1;
}
